'use client'

import { AppProgressProvider } from '@bprogress/next'
import type { ReactNode } from 'react'

const LoadingProgress = ({ children }: { children: ReactNode }) => (
  <AppProgressProvider color="#555" height="2px" options={{ showSpinner: false }}>
    {children}
  </AppProgressProvider>
)

export default LoadingProgress
